import React from "react";
import DynamicComponent from "./DynamicComponent";
import SbEditable from "storyblok-react";
import Seo from "../utils/seo";

const Page = ({ name, blok }) => {
  const content =
    blok.body &&
    blok.body.map((childBlok) => (
      <DynamicComponent blok={childBlok} key={childBlok._uid} />
    ));
  const title = blok.meta?.title || `${name} | Govox`;
  return (
    <SbEditable content={blok} key={blok._uid}>
      <Seo
        title={title}
        description={blok.meta?.description}
        noindex={blok?.no_index}
        canonical={blok.canonical_override?.cached_url}
      />
      {content}
    </SbEditable>
  );
};

export default Page;
